import ApiService from '@/services/api.service'

const MenuService = {

    getMenu(){
        return ApiService.get(`/Menus?Device=WEB&LoadUserSelectedModule=true&Operation=LoadingMainMenu`);
    },

    getMenuStatic(){
           return   [
             /* {
              "type": "submenu",
              "code": "2",
              "header": false,
              "hiddenOnCollapse": false,
              "title": "Company",
              "originalTitle": "Company",
              "href": "/app/setupcompany",
              "hasAdd": true,
              "hasEdit": true,
              "hasDelete": true,
              "roleCanView": true,
              "roleCanAdd": true,
              "roleCanEdit": true,
              "roleCanDelete": true,
              "roleDisabledBySetting": true,
              "icon": "ikon med-doc-new",
              "class":"menuItemStatic",
              "child": null
              },*/
              {
              "type": "submenu",
              "code": "3",
              "header": false,
              "hiddenOnCollapse": true,
              "title": "Companies",
              "originalTitle": "Companies",
              "href": "/app/setupcompanies",
              "hasAdd": true,
              "hasEdit": true,
              "hasDelete": true,
              "roleCanView": true,
              "roleCanAdd": true,
              "roleCanEdit": true,
              "roleCanDelete": true,
              "roleDisabledBySetting": true,
              "icon": "ikon med-doc-new",
              "class":"menuItemStatic",
              "child": null
              },
             /* {
              "type": "submenu",
              "code": "4",
              "header": false,
              "hiddenOnCollapse": true,
              "title": "Roles",
              "originalTitle": "Roles",
              "href": "/app/setuproles",
              "hasAdd": true,
              "hasEdit": true,
              "hasDelete": true,
              "roleCanView": true,
              "roleCanAdd": true,
              "roleCanEdit": true,
              "roleCanDelete": true,
              "roleDisabledBySetting": true,
              "icon": "ikon med-doc-new",
              "class":"menuItemStatic",
              "child": null
              },*/
              {
              "type": "submenu",
              "code": "5",
              "header": false,
              "hiddenOnCollapse": true,
              "title": "Users",
              "originalTitle": "Users",
              "href": "/app/setupusers",
              "hasAdd": true,
              "hasEdit": true,
              "hasDelete": true,
              "roleCanView": true,
              "roleCanAdd": true,
              "roleCanEdit": true,
              "roleCanDelete": true,
              "roleDisabledBySetting": true,
              "icon": "ikon med-doc-new",
              "class":"menuItemStatic",
              "child": null
              },
              {
              "type": "submenu",
              "code": "7",
              "header": false,
              "hiddenOnCollapse": true,
              "title": "Services",
              "originalTitle": "Services",
              "href": "/app/setuptherapies",
              "hasAdd": true,
              "hasEdit": true,
              "hasDelete": true,
              "roleCanView": true,
              "roleCanAdd": true,
              "roleCanEdit": true,
              "roleCanDelete": true,
              "roleDisabledBySetting": true,
              "icon": "ikon med-doc-new",
              "class":"menuItemStatic",
              "child": null
              },               
              {
              "type": "submenu",
              "code": "6",
              "header": false,
              "hiddenOnCollapse": true,
              "title": "Programs",
              "originalTitle": "Programs",
              "href": "/app/setupprograms",
              "hasAdd": true,
              "hasEdit": true,
              "hasDelete": true,
              "roleCanView": true,
              "roleCanAdd": true,
              "roleCanEdit": true,
              "roleCanDelete": true,
              "roleDisabledBySetting": true,
              "icon": "ikon med-doc-new",
              "class":"menuItemStatic",
              "child": null
              },
               {
              "type": "submenu",
              "code": "8",
              "header": false,
              "hiddenOnCollapse": true,
              "title": "Notes",
              "originalTitle": "Notes",
              "href": "/app/setupnotes",
              "hasAdd": true,
              "hasEdit": true,
              "hasDelete": true,
              "roleCanView": true,
              "roleCanAdd": true,
              "roleCanEdit": true,
              "roleCanDelete": true,
              "roleDisabledBySetting": true,
              "icon": "ikon med-doc-new",
              "class":"menuItemStatic",
              "child": null
              },
              {
              "type": "submenu",
              "code": "9",
              "header": false,
              "hiddenOnCollapse": true,
              "title": "Appointments",
              "originalTitle": "Appointments",
              "href": "/app/setupapptypes",
              "hasAdd": true,
              "hasEdit": true,
              "hasDelete": true,
              "roleCanView": true,
              "roleCanAdd": true,
              "roleCanEdit": true,
              "roleCanDelete": true,
              "roleDisabledBySetting": true,
              "icon": "ikon med-doc-new",
              "class":"menuItemStatic",
              "child": null
              },  
              {
              "type": "submenu",
              "code": "13",
              "header": false,
              "hiddenOnCollapse": true,
              "title": "Referrals",
              "originalTitle": "Referrals",
              "href": "/app/setupreferral",
              "hasAdd": true,
              "hasEdit": true,
              "hasDelete": true,
              "roleCanView": true,
              "roleCanAdd": true,
              "roleCanEdit": true,
              "roleCanDelete": true,
              "roleDisabledBySetting": true,
              "icon": "ikon med-doc-new",
              "class":"menuItemStatic",
              "child": null
              },  
              {
              "type": "submenu",
              "code": "12",
              "header": false,
              "hiddenOnCollapse": true,
              "title": "Insurances",
              "originalTitle": "Insurances",
              "href": "/app/setupinsurance",
              "hasAdd": true,
              "hasEdit": true,
              "hasDelete": true,
              "roleCanView": true,
              "roleCanAdd": true,
              "roleCanEdit": true,
              "roleCanDelete": true,
              "roleDisabledBySetting": true,
              "icon": "ikon med-doc-new",
              "class":"menuItemStatic",
              "child": null
              },   
              {
              "type": "submenu",
              "code": "10",
              "header": false,
              "hiddenOnCollapse": true,
              "title": "Review and Submit",
              "originalTitle": "Review and Submit",
              "href": "/app/setupreviewsubmit",
              "hasAdd": true,
              "hasEdit": true,
              "hasDelete": true,
              "roleCanView": true,
              "roleCanAdd": true,
              "roleCanEdit": true,
              "roleCanDelete": true,
              "roleDisabledBySetting": true,
              "icon": "ikon med-sign-n-save",
              "class":"menuItemStatic",
              "child": null
              }]
    },

    getTestgMenu(){
        return [ {
            "type": "header",
            "code": "442373854011698",
            "header": false,
            "hiddenOnCollapse": false,
            "title": "Dashboards",
            "href": null,
            "icon": "med-isologo",
            "child": [
              {
                  "type": "menu",
                  "code": "442366253323153",
                  "header": false,
                  "hiddenOnCollapse": false,
                  "title": "Patient Dashboard",
                  "href": "/app/patients",
                  "icon": null,
                  "child": []
              },
              {
                  "type": "menu",
                  "code": "442366253323153",
                  "header": false,
                  "hiddenOnCollapse": false,
                  "title": "Clinical Dashboard",
                  "href": "/app/clinical",
                  "icon": null,
                  "child": []
              }            
          ]
      } , 
      {
          "type": "header",
          "code": "442373854011698",
          "header": false,
          "hiddenOnCollapse": false,
          "title": "Reports",
          "href": null,
          "icon": "mdi mdi-arrow-right-drop-circle",
          "child": [
              {
                  "type": "category",
                  "code": "442373856283458",
                  "header": true,
                  "hiddenOnCollapse": false,
                  "title": "Financial",
                  "href": null,
                  "icon": null,
                  "child": null
              },
              {
                  "type": "menu",
                  "code": "442366253323153",
                  "header": false,
                  "hiddenOnCollapse": false,
                  "title": "Patient",
                  "href": null,
                  "icon": null,
                  "child": [
                          {
                            "type": "menu",
                            "code": "442366253323153",
                            "header": false,
                            "hiddenOnCollapse": false,
                            "title": "Patient Census",
                            "href": null,
                            "icon": null,
                            "child": null
                          },
                          {
                            "type": "menu",
                            "code": "442366253323153",
                            "header": false,
                            "hiddenOnCollapse": false,
                            "title": "Patient Admissions",
                            "href": null,
                            "icon": null,
                            "child": null
                          },                              
                  ]
              },
              {
                  "type": "menu",
                  "code": "442366253323153",
                  "header": false,
                  "hiddenOnCollapse": false,
                  "title": "Employee",
                  "href": null,
                  "icon": null,
                  "child": [
                          {
                            "type": "menu",
                            "code": "442366253323153",
                            "header": false,
                            "hiddenOnCollapse": false,
                            "title": "Employee Census",
                            "href": null,
                            "icon": null,
                            "child": null
                          },
                        {
                            "type": "menu",
                            "code": "442366253323153",
                            "header": false,
                            "hiddenOnCollapse": false,
                            "title": "Employee Admissions",
                            "href": null,
                            "icon": null,
                            "child": null
                          },                              
                  ]
              },
            {
                  "type": "category",
                  "code": "442373856283458",
                  "header": true,
                  "hiddenOnCollapse": false,
                  "title": "Statisticals",
                  "href": null,
                  "icon": null,
                  "child": null
              },
              {
                  "type": "menu",
                  "code": "442366253323153",
                  "header": false,
                  "hiddenOnCollapse": false,
                  "title": "Patient Stats",
                  "href": null,
                  "icon": null,
                  "child": [
                          {
                            "type": "menu",
                            "code": "442366253323153",
                            "header": false,
                            "hiddenOnCollapse": false,
                            "title": "Patient Census Stats",
                            "href": null,
                            "icon": null,
                            "child": null
                          },
                          {
                            "type": "menu",
                            "code": "442366253323153",
                            "header": false,
                            "hiddenOnCollapse": false,
                            "title": "Patient Admissions Stats",
                            "href": null,
                            "icon": null,
                            "child": null
                          },                              
                        ]
                    },
                    {
                        "type": "menu",
                        "code": "442366253323153",
                        "header": false,
                        "hiddenOnCollapse": false,
                        "title": "Employee Stats",
                        "href": null,
                        "icon": null,
                        "child": [
                            {
                              "type": "menu",
                              "code": "442366253323153",
                              "header": false,
                              "hiddenOnCollapse": false,
                              "title": "Employee Census Stats",
                              "href": null,
                              "icon": null,
                              "child": null
                            },
                          {
                              "type": "menu",
                              "code": "442366253323153",
                              "header": false,
                              "hiddenOnCollapse": false,
                              "title": "Employee Admissions Stats",
                              "href": null,
                              "icon": null,
                              "child": null
                            },                              
                        ]
                    }, 
                    {
                        "type": "category",
                        "code": "442373856283458",
                        "header": true,
                        "hiddenOnCollapse": false,
                        "title": "OTHERS",
                        "href": null,
                        "icon": null,
                        "child": null
                    },                                   
                    {
                        "type": "menu",
                        "code": "442366253323153",
                        "header": false,
                        "hiddenOnCollapse": false,
                        "title": "Discharge Report",
                        "href": null,
                        "icon": null,
                        "child": []
                    },
                    {
                        "type": "menu",
                        "code": "442366253323153",
                        "header": false,
                        "hiddenOnCollapse": false,
                        "title": "Scheduler Report",
                        "href": null,
                        "icon": null,
                        "child": []
                    },            
                ]
            }    
          ]
    }
}

export default MenuService;